import React from 'react';
import { Alert, Grid, TextField, Typography } from "@mui/material";

// Sueldo y jornada del conductor: lo que el costeo del viaje necesita saber de la persona.
//
// Vive acá y no en la configuración de ruteo de la empresa porque son datos de cada uno. Lo que
// quede vacío lo sigue heredando de la empresa, así que llenar solo el sueldo ya sirve.
//
// Las claves son las mismas que usa `Routing::Settings`: el backend acepta exactamente estas
// (DRIVER_KEYS) para un usuario y descarta el resto.
export const DRIVER_COST_FIELDS = [
    { key: 'driver_net_salary', label: 'Sueldo líquido mensual', type: 'number' },
    { key: 'driver_cost_factor', label: 'Factor de leyes sociales', type: 'number', placeholder: '1,40' },
    { key: 'driver_hours_per_month', label: 'Horas al mes', type: 'number', placeholder: '182' },
    { key: 'workday_start', label: 'Jornada desde', type: 'text', placeholder: '08:30' },
    { key: 'workday_end', label: 'Jornada hasta', type: 'text', placeholder: '18:00' },
    { key: 'driver_cost_per_hour', label: 'Costo por hora, si no cargás sueldo', type: 'number' },
];

// La misma fórmula del backend, solo para previsualizar mientras se escribe. El valor que manda
// es el que calcula Routing::Settings al costear, y ahí el derivado del sueldo le gana al
// costo por hora cargado a mano.
export const costoPorHora = (settings = {}) => {
    const liquido = Number(settings.driver_net_salary);
    if (!liquido) return null;

    const factor = Number(settings.driver_cost_factor) || 1.4;
    const horas = Number(settings.driver_hours_per_month) || 173.33;
    if (!horas) return null;

    return Math.round((liquido * factor) / horas);
};

const DriverCostFields = ({ settings = {}, onChange, disabled = false }) => {
    const porHora = costoPorHora(settings);

    const set = (key) => (e) => onChange({ ...settings, [key]: e.target.value });

    return (
        <React.Fragment>
            <Typography variant="h4" color="primary" sx={{ mt: 3 }}>Costeo del conductor</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                Se usa para costear los viajes que maneje. Lo que dejés vacío lo hereda de la
                configuración de ruteo de la empresa.
            </Typography>
            <Grid container spacing={2} sx={{ pt: 1 }}>
                {DRIVER_COST_FIELDS.map((campo) => (
                    <Grid item xs={6} lg={4} key={campo.key}>
                        <TextField
                            fullWidth
                            size="small"
                            type={campo.type}
                            label={campo.label}
                            placeholder={campo.placeholder}
                            disabled={disabled}
                            value={settings[campo.key] ?? ''}
                            onChange={set(campo.key)}
                        />
                    </Grid>
                ))}
            </Grid>
            {porHora !== null && (
                <Alert severity="success" sx={{ mt: 1.5, py: 0.5 }}>
                    <Typography variant="body2">
                        {`Costo por hora: $${porHora.toLocaleString("es-CL")}`}
                        {` · costo empresa mensual: $${Math.round(Number(settings.driver_net_salary) * (Number(settings.driver_cost_factor) || 1.4)).toLocaleString("es-CL")}`}
                    </Typography>
                </Alert>
            )}
        </React.Fragment>
    );
};

export default DriverCostFields;
